<script>
import DropDown from '../reUse/DropDown.vue';
import DnevnikBeri from './Dnevnik_beri.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from  '@/Prevodi/DnevnikPilotov-sl.json';
import en from  '@/Prevodi/DnevnikPilotov-en.json';
import it from  '@/Prevodi/DnevnikPilotov-it.json';
import {config} from "@/config";
export default {
  components: {
    DropDown,
    DnevnikBeri,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      prikaz: 'vnosi',
      krajVzleta: '',
      krajPristanka: '',
      regLetala: '',
      pogoji: 'dan',
      pristanki: '',
      operativa: 'dnevno',
      imeVodje: '',
      fstd: '',
      datum: '',
      vloga: 'PIC',
      ttof: '',
      posadka: 'SE',
      odhod_cas: '',
      prihod_cas: '',
      varianta: '',
      opombe: '',
      dVzlet: false,
      dPristanek: false,
      dLetalo: false,
      Letala: [],
      LetalaMotorna: [],
      Letalisca: [],
      text: '',
      types: '',
      ShowNoti: false,
      user: config.FullUser.id,
    };
  },
  computed: {},
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetLetalisca();
  },
  methods: {
    VnosPLogBook() {
      let app = this;
      if (this.datum !== '' && this.imeVodje !== '' && this.odhod_cas !== '' && this.prihod_cas !== '' && this.ttof !== '' && this.krajPristanka !== '' && this.krajVzleta !== '' && this.pristanki !== '' && this.varianta !== '' && this.regLetala !== '') {
        var php_podatki = new URLSearchParams();
        php_podatki.append('datum', this.datum);
        php_podatki.append('ime_vodja_zrakoplova', this.imeVodje);
        php_podatki.append('odhod_cas', this.odhod_cas);
        php_podatki.append('odhod_kraj', this.krajVzleta);
        php_podatki.append('opombe', this.opombe);
        php_podatki.append('pilot_id', this.user);
        php_podatki.append('pogoji', this.operativa);
        php_podatki.append('posadka', this.posadka);
        php_podatki.append('prihod_cas', this.prihod_cas);
        php_podatki.append('prihod_kraj', this.krajPristanka);
        php_podatki.append('pristanki', this.pogoji);
        php_podatki.append('s_cas_FSTD', this.fstd);
        php_podatki.append('st_pristajanj', this.pristanki);
        php_podatki.append('ttof', this.ttof);
        php_podatki.append('vloga_pilota', this.vloga);
        php_podatki.append('zrakoplov_model', this.varianta);
        php_podatki.append('zrakoplov_registracija', this.regLetala);
        axios
            .post('./api/pl_dodaj/', php_podatki, {withCredentials: true})
            .then(function (response) {
              app.text = app.$t('obvestila.zapisDodan');
              app.types = "Uspešno";
              app.ShowNoti = true;
              app.datum = '';
              app.imeVodje = '';
              app.odhod_cas = '';
              app.krajVzleta = '';
              app.opombe = '';
              app.operativa = 'dnevno';
              app.posadka = 'SE';
              app.prihod_cas = '';
              app.krajPristanka = '';
              app.pogoji = 'dan';
              app.pristanki = '';
              app.fstd = '';
              app.ttof = '';
              app.vloga = 'PIC';
              app.varianta = '';
              app.regLetala = '';
              var requiredPolja = ['datum', 'imeVodje', 'prihod_cas', 'odhod_cas', 'krajPristanka', 'krajVzleta', 'pristanki', 'varianta', 'regLetala', 'ttof'];
              app.ResetRequired(requiredPolja);
            })
            .catch(napaka => {
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.sporocilo !== undefined) {
                this.text = this.$t('obvestila.napakaVnosa');
              } else {
                this.text = this.$t('obvestila.napakaVnosa');
              }
              this.types = "Napaka";
              this.ShowNoti = true;
            });
      } else {
        var requiredPolja = ['datum', 'imeVodje', 'prihod_cas', 'odhod_cas', 'krajPristanka', 'krajVzleta', 'pristanki', 'varianta', 'regLetala', 'ttof'];
        this.CheckInputs(requiredPolja);
        this.text = this.$t('obvestila.napakaInputa');
        this.types = "Napaka";
        this.ShowNoti = true;
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]); //samo za dev
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch((napaka) => {
            // alert("Napaka pri vnosu: " + napaka.response.data.message);
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            this.text = this.$t('obvestila.napakaBranja');
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Jadralno') {
                app.Letala.push(response.data.letala[i]);
              } else if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.LetalaMotorna.push(response.data.letala[i]);
              }
            }
            // app.LetalaMotorna = app.LetalaMotorna.filter(letalo => letalo.vlecno == true); //dodano filtriranje za prikaz samo letal, ki so označena za vleko
            // alert("Zapis uspešno dodan!");
            // app.LetalaMotorna = response.data;
          })
          .catch((napaka) => {
            // alert("Napaka pri vnosu: " + napaka.response.data.message);
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            this.text = this.$t('obvestila.napakaBranja');
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectLetalo(id) {
      // let letalo = this.Letala.letala.find(l => l.id === id);
      let letalo = this.LetalaMotorna.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    IzpolniTTOF() {
      if (this.prihod_cas !== '') {
        this.ttof = this.razlikaUr(this.odhod_cas, this.prihod_cas);
      }
    },
    razlikaUr(cas1, cas2) {
      const [h1, m1] = cas1.split(":").map(Number);
      const [h2, m2] = cas2.split(":").map(Number);
      let minute1 = h1 * 60 + m1;
      let minute2 = h2 * 60 + m2;
      if (minute2 < minute1) {
        minute2 += 24 * 60;
      }
      const razlika = minute2 - minute1;
      var ure = Math.floor(razlika / 60);
      var minute = razlika % 60;
      if (ure < 10) {
        ure = '0' + ure;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      return `${ure}:${minute}`;
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnosi'}" @click="prikaz = 'vnosi'" data-umami-event="DnevnikPilotov-Motorni-vnosi">
              <i class="fas fa-edit"></i>
              <span>{{$t('navs.vnos')}}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'branje'}" @click="prikaz = 'branje'" data-umami-event="DnevnikPilotov-Motorni-branje">
              <i class="fas fa-list"></i>
              <span>{{$t('navs.dnevnik')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
  <dnevnik-beri v-if="prikaz === 'branje'" :user="user" />
  <div v-else class="container p-2">
    <!-- DATUM -->
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum">{{$t('labels.datum')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required />
      </div>
    </div>
    <!-- ČAS VZLETA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: odhod_cas.length > 0 }" class="label-time p-2" for="odhod_cas">{{$t('labels.casO')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="odhod_cas" v-model="odhod_cas" @change="IzpolniTTOF()" required />
      </div>
    </div>
    <!-- KRAJ PRISTANKA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: krajVzleta.length > 0 }" class="label" for="krajVzleta">{{$t('labels.krajV')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" v-model="krajVzleta" required />
        <!--                 <label class="label-dropdown" for="namen">Izberi vzlet : <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajVzleta = ''">Pobriši izbiro</button></label>
                        <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
                            <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
                            <i v-show="dVzlet" class="fas fa-chevron-down"></i>
                        </div>
                        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" @click.prevent="OpenVzlet">{{krajVzleta}}</button>
                        <transition name="fade">
                            <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" class="drop-down-btn" v-if="dVzlet" />
                        </transition>     -->
      </div>
    </div>
    <!-- ČAS PRIHODA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: prihod_cas.length > 0 }" class="label-time p-2" for="prihod_cas">{{$t('labels.casP')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="prihod_cas" v-model="prihod_cas" @change="IzpolniTTOF()" required />
      </div>
    </div>
    <!-- KRAJ PRISTANKA-->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: krajPristanka.length > 0 }" class="label" for="krajPristanka">{{$t('labels.krajP')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" v-model="krajPristanka" required />
        <!--                 <label class="label-dropdown" for="krajPristanka">Izberi pristanek : <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajPristanka = ''">Pobriši izbiro</button></label>
                        <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
                            <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
                            <i v-show="dPristanek" class="fas fa-chevron-down"></i>
                        </div>
                        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" @click.prevent="OpenPristanek">{{krajPristanka}}</button>
                        <transition name="fade">
                            <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" class="drop-down-btn" v-if="dPristanek" />
                        </transition>     -->
      </div>
    </div>
    <!-- MODEL, VARIANTA ZRAKOPLOVA-->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: varianta.length > 0 }" class="label" for="varianta">{{$t('labels.model')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="varianta" v-model="varianta" required />
      </div>
    </div>
    <!-- REGISTRACIJA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: regLetala.length > 0 }" class="label" for="regLetala">{{$t('labels.reg')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" v-model="regLetala" required />
      </div>
      <!-- <label class="label-dropdown" for="regLetala">Izberi registracijo letala : <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''">Pobriši izbiro</button></label>
      <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
      </div>
      <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
      <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="LetalaMotorna" type="letalo" class="drop-down-btn" v-if="dLetalo" />
      </transition>     -->
    </div>
    <!-- IME VODJE ZRAKOPLOVA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: imeVodje.length > 0 }" class="label" for="imeVodje">{{$t('labels.ime')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="imeVodje" v-model="imeVodje" required />
      </div>
    </div>
    <!-- POSADKA -->
    <div class="col-12">
      <div class="container">
        <label class="label-time p-2" for="posadka">{{$t('labels.posadka')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <div class="row">
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="SE" value="SE" />
              <label class="p-1 font-phone" style="color: white;" for="posadka"> SE</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="ME" value="ME" />
              <label class="p-1 font-phone" style="color: white;" for="posadka"> ME</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="vec" value="vec" />
              <label class="p-1 font-phone" style="color: white;" for="posadka"> {{$t('labels.posadkaVec')}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TTOF -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: ttof.length > 0 }" class="label-time p-2" for="ttof">{{$t('labels.skupniCas')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="TTOF" id="ttof" v-model="ttof" required />
      </div>
    </div>
    <!-- ŠT PRISTANKOV  dan/noc-->
    <div class="col-12">
      <div class="container">
        <label class="label-time p-2" for="pogoji">{{$t('labels.stPristankovDN')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <div class="row">
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="pogoji" inputId="pogoji" name="danpogoj" value="dan" />
              <label class="p-1" style="color: white;" for="pogoji"> {{$t('labels.dan')}}</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="pogoji" inputId="pogoji" name="nocpogoj" value="noc" />
              <label class="p-1" style="color: white;" for="pogoji"> {{$t('labels.noc')}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ŠT. PRISTANKOV številka-->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: pristanki > 0 }" class="label" for="pristanki">{{$t('labels.stPristankov')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="pristanki" v-model="pristanki" required />
      </div>
    </div>
    <!-- OPERATIVNI POGOJI -->
    <div class="col-12">
      <div class="container">
        <label class="label-time p-2" for="operativa">{{$t('labels.op')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <div class="row">
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="dan" value="dnevno" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> {{$t('labels.opD')}}</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="noc" value="nocno" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> {{$t('labels.opN')}}</label>
            </div>
            <div class="col-4 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="ifr" value="ifr" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> IFR</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- VLOGA PILOTA -->
    <div class="col-12">
      <div class="container">
        <label class="label-time p-2" for="operativa">{{$t('labels.vlogaP')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <div class="row">
            <div class="col-3 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="vloga" inputId="operativa" name="pic" value="PIC" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> PIC</label>
            </div>
            <div class="col-3 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="vloga" inputId="operativa" name="cop" value="COP" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> COP</label>
            </div>
            <div class="col-3 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="vloga" inputId="operativa" name="dual" value="DUAL" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> DUAL</label>
            </div>
            <div class="col-3 text-center">
              <input class="scale-phone" style="scale: 1.4;" type="radio" v-model="vloga" inputId="operativa" name="inst" value="INST" />
              <label class="p-1 font-phone" style="color: white;" for="operativa"> FI</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FSTD -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: fstd > 0 }" class="label" for="fstd">{{$t('labels.fstd')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="fstd" v-model="fstd" required />
      </div>
    </div>
    <!-- OPOMBE -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opombe.length > 0 }" class="label" for="opombe">{{$t('labels.opomba')}}</label>
        <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opombe" v-model="opombe" rows="6" autocomplete="off">
                </textarea>
      </div>
    </div>
    <!-- GUMB ZA DODAJANJE-->
    <div class="container p-2">
      <button @click.prevent="VnosPLogBook()" class="btn btn-primary rounded-pill btn-add col-12">{{$t('buttons.vnesiZapis')}}</button>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>